"use client";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import DeleteAction from "@/components/SocialNetworks/DeleteAction";
import React, {useState} from "react";
import CommentUpdateForm from "@/components/SocialNetworks/Comment/CommentUpdateForm";

export default function CommentMenuEdit({commentId, comment}){
    const [openDelete, setOpenDelete] = useState(false);
    const [openUpdate, setOpenUpdate] = useState(false);
    return(
        <>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <button>...</button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className={"w-24 mr-10 "}>
                    <DropdownMenuGroup>
                        <DropdownMenuItem onClick={() => setOpenUpdate(true)}>
                            <button className={""}>Modifier</button>
                        </DropdownMenuItem>

                        <DropdownMenuItem  onClick={() => setOpenDelete(true)}>
                            <p className={"text-red-500"}>Supprimer</p>
                        </DropdownMenuItem>
                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenu>
            <DeleteAction
                title={"Suppression du commentaire"}
                type={"comment"}
                idType={commentId}
                content={"Êtes vous sûr de vouloir supprimer votre commentaire ?"}
                openDelete={openDelete}
                setOpenDelete={setOpenDelete}
            />
            <CommentUpdateForm setOpenComment={setOpenUpdate} comment={comment} idComment={commentId} openComment={openUpdate}/>
        </>

    )
}